import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var ACTIVITY_STREAM_EVENT_CATEGORY = 'ActivityStream';
var ActivityStreamEvents = {
    pageView: ACTIVITY_STREAM_EVENT_CATEGORY + "_Open",
    rangeDailySelect: ACTIVITY_STREAM_EVENT_CATEGORY + "_RangeDaily_Select",
    rangeWeeklySelect: ACTIVITY_STREAM_EVENT_CATEGORY + "_RangeWeekly_Select",
    rangeMonthlySelect: ACTIVITY_STREAM_EVENT_CATEGORY + "_RangeMonthly_Select",
    rangeYearlySelect: ACTIVITY_STREAM_EVENT_CATEGORY + "_RangeYearly_Select",
    tableSortByTimeSpentClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_SortByTS_Click",
    tableSortByStudentsNameClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_SortBySN_Click",
    tableSortByTasksClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_SortByNT_Click",
    tableSortByAccuracyClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_SortByAL_Click",
    tableSortByStruggleTasksClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_SortByST_Click",
    studentLinkClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentName_Click",
    downloadReportClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_DownloadReport",
    studentRowExpand: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_Open",
    struggleStudentRowExpand: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_Struggle_Open",
    studentTopicExpand: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_TopicTasks_Open",
    studentCardClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_OpenCard_NoStruggle",
    studentStruggleCardClick: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_OpenCard_Struggle",
    studentStruggleFilterEnable: ACTIVITY_STREAM_EVENT_CATEGORY + "_StudentMenu_FilterStuggle",
};
var useActivityStreamAnalytics = function () {
    return useFeatureGoogleAnalytics(ACTIVITY_STREAM_EVENT_CATEGORY);
};
export { useActivityStreamAnalytics, ActivityStreamEvents };
